import "core-js/modules/es.array.push.js";
import IceCubeItem from "@/components/subject/Cube/IceCubeItem.vue";
import LogicalTransformer2DImg from "@/components/subject/LogicalTransformer2D/LogicalTransformer2DImg.vue";
import api from "@/api";
import { ElMessage } from "element-plus";
export default {
  name: "StereoProjectionEditor",
  components: {
    LogicalTransformer2DImg,
    IceCubeItem
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return null;
      }
    },
    runtimeParams: {
      type: Object,
      default: () => {
        return null;
      }
    },
    initRuntimeParams: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      imgs: [],
      previewData: {},
      letters: ['A', 'B', 'C', 'D']
    };
  },
  watch: {
    data: {
      handler() {
        this.init();
      },
      deep: true
    }
  },
  methods: {
    checkIsSaveAll() {
      if (this.imgs.length < 4) {
        ElMessage.error('题目图片不得少于4张');
        return false;
      }
      return true;
    },
    saveAll(tplId) {
      this.previewData[this.data.questionIndex] = this.imgs;
      api.updateTplRuntimeParams({
        tplId,
        runtimeParams: JSON.stringify(this.previewData)
      }).then(() => {
        ElMessage({
          message: '套题已保存',
          type: 'warning'
        });
      });
    },
    deleteImg(idx) {
      this.imgs.splice(idx, 1);
    },
    handleSaveImage(imgUrl, index, isDesc) {
      this.imgs.push(imgUrl);
    },
    init() {
      const idx = this.data.questionIndex;
      if (this.previewData[idx]) {
        this.imgs = this.previewData[idx];
      } else if (this.runtimeParams) {
        this.imgs = this.runtimeParams || [];
      } else {
        this.imgs = [];
      }
    }
  },
  mounted() {
    this.init();
  }
};